import React from "react";
import { createTheme } from "@mui/material";
import rtlPlugin from "stylis-plugin-rtl";
import { CacheProvider } from "@emotion/react";
import createCache from "@emotion/cache";

// Soft UI React base styles
import colors from "./theme/base/colors";
import breakpoints from "./theme/base/breakpoints";
import boxShadows from "./theme/base/boxShadows";
import borders from "./theme/base/borders";
import globals from "./theme/base/globals";

// Soft UI React helper functions
import boxShadow from "./theme/functions/boxShadow";
import hexToRgb from "./theme/functions/hexToRgb";
import linearGradient from "./theme/functions/linearGradient";
import pxToRem from "./theme/functions/pxToRem";
import rgba from "./theme/functions/rgba";

// Soft UI React components base styles for @mui material components
import sidenav from "./theme/components/sidenav";
import list from "./theme/components/list";
import listItem from "./theme/components/list/listItem";
import listItemText from "./theme/components/list/listItemText";
import card from "./theme/components/card";
import cardMedia from "./theme/components/card/cardMedia";
import cardContent from "./theme/components/card/cardContent";
import button from "./theme/components/button";
import iconButton from "./theme/components/iconButton";
import inputBase from "./theme/components/form/inputBase";
import menu from "./theme/components/menu";
import menuItem from "./theme/components/menu/menuItem";
import switchButton from "./theme/components/form/switchButton";
import divider from "./theme/components/divider";
import linearProgress from "./theme/components/linearProgress";
import breadcrumbs from "./theme/components/breadcrumbs";
import slider from "./theme/components/slider";
import avatar from "./theme/components/avatar";
import tooltip from "./theme/components/tooltip";
import appBar from "./theme/components/appBar";
import tabs from "./theme/components/tabs";
import tab from "./theme/components/tabs/tab";
import stepper from "./theme/components/stepper";
import step from "./theme/components/stepper/step";
import stepContent from "./theme/components/stepper/stepContent";
import stepConnector from "./theme/components/stepper/stepConnector";
import stepLabel from "./theme/components/stepper/stepLabel";
import select from "./theme/components/form/select";
import formLabel from "./theme/components/form/formLabel";
import checkbox from "./theme/components/form/checkbox";
import radio from "./theme/components/form/radio";
import container from "./theme/components/container";
import popover from "./theme/components/popover";
import buttonBase from "./theme/components/buttonBase";
import icon from "./theme/components/icon";
import svgIcon from "./theme/components/svgIcon";
import link from "./theme/components/link";
import inputAdornment from "assets/theme/components/form/inputAdornment";
export const customTheme = createTheme({
    direction: "rtl",
    typography: {
        fontFamily: "YekanBakh"
    },
    shape: {
        borderRadius: 8
    },
    breakpoints: { ...breakpoints },
    palette: { ...colors },
    boxShadows: { ...boxShadows },
    borders: { ...borders },
    functions: {
        boxShadow,
        hexToRgb,
        linearGradient,
        pxToRem,
        rgba
    },
    components: {
        MuiCssBaseline: {
            styleOverrides: {
                ...globals,
                ...container
            }
        },
        MuiDrawer: { ...sidenav },
        MuiList: { ...list },
        MuiListItem: { ...listItem },
        MuiListItemText: { ...listItemText },
        MuiCard: { ...card },
        MuiCardMedia: { ...cardMedia },
        MuiCardContent: { ...cardContent },
        MuiButton: { ...button },
        ///MuiIconButton: { ...iconButton },
        MuiInputBase: { ...inputBase },
        MuiMenu: { ...menu },
        MuiMenuItem: { ...menuItem },
        // MuiSwitch: { ...switchButton },
        MuiDivider: { ...divider },
        // MuiTableContainer: { ...tableContainer },
        // MuiTableHead: { ...tableHead },
        // MuiTableCell: { ...tableCell },
        // MuiLinearProgress: { ...linearProgress },
        MuiBreadcrumbs: { ...breadcrumbs },
        MuiSlider: { ...slider },
        //MuiAvatar: { ...avatar },
        MuiTooltip: { ...tooltip },
        MuiAppBar: { ...appBar },
        MuiTabs: { ...tabs },
        MuiTab: { ...tab },
        MuiStepper: { ...stepper },
        MuiStep: { ...step },
        MuiStepContent: { ...stepContent },
        MuiStepConnector: { ...stepConnector },
        MuiStepLabel: { ...stepLabel },
        // MuiStepIcon: { ...stepIcon },
        //MuiSelect: { ...select },
        // MuiFormControlLabel: { ...formControlLabel },
        MuiFormLabel: { ...formLabel },
        //MuiCheckbox: { ...checkbox },
        MuiRadio: { ...radio },
        // MuiAutocomplete: { ...autocomplete },
        // MuiInput: { ...input },
        // MuiOutlinedInput: { ...input },
        // MuiFilledInput: { ...input },
        MuiPopover: { ...popover },
        MuiButtonBase: { ...buttonBase },
       // MuiIcon: { ...icon },
        //MuiSvgIcon: { ...svgIcon },
        MuiLink: { ...link },
        MuiInputAdornment: { ...inputAdornment }
    }
});

// Create rtl cache
const cacheRtl = createCache({
    key: "muirtl",
    stylisPlugins: [rtlPlugin]
});

export const RTL = props => {
    return <CacheProvider value={cacheRtl}>{props.children}</CacheProvider>;
};
